import { useLocation } from 'react-router'
import { upperFirst } from 'lodash'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { uiStore } from 'shared/store/uiStore'
import { BreadcrumbsUi } from './BreadcrumbsUi'

type ISkipCountProps = {
  skippedCountLastRoutesForLabel?: number
  storyData?: string
  getLabel?: (path: string) => string | undefined
  customPath?: string
  className?: string
}

export const Breadcrumbs = observer(
  ({
    skippedCountLastRoutesForLabel = 0,
    getLabel,
    storyData,
    customPath,
    className,
  }: ISkipCountProps) => {
    const { prevPathName, customPathLabel } = uiStore
    const { pathname } = useLocation()
    let path: string
    if (customPath) {
      path = customPath
    } else if (prevPathName) {
      path = prevPathName
    } else {
      path = pathname.split('/').slice(0, -1).join('/')
    }
    const label = useMemo(() => {
      if (customPathLabel[path]) {
        return customPathLabel[path]
      }
      if (getLabel && getLabel(path)) {
        return getLabel(path)
      }
      return path.split('/').at(-1 + skippedCountLastRoutesForLabel * -1)
    }, [path, skippedCountLastRoutesForLabel])

    return (
      <BreadcrumbsUi
        storyData={storyData}
        path={path}
        label={upperFirst(label?.replace(/_/g, ' '))}
        className={className}
      />
    )
  }
)
